export default "__VITE_ASSET__dhnhX3d9__"